/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class GestorNotificacionClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  putStopNotifications = async (data) => {
    try {
      const response = await this.request('put')(
        { data },
        { path: 'gestnotif/suscripciones' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  getStopNotifications = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'gestnotif/suscripciones' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  shareMobileMessage = async (data) => {
    console.log('shareMobileMessage', data);
    try {
      const response = await this.request('post')(
        { data },
        { path: 'gestnotif/shareMobileMessage' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}
